import * as React from 'react';
import {useEffect} from 'react';
import System from "../../helper/system";
import $ from "jquery";

let c = System.getParams();

const NoDataFound = (props) => {
    useEffect(() => {
        async function fetchHere() {
            localStorage.setItem('product_listing_page', 1);
            c.search = c.search ? c.search : localStorage.getItem('universal_search_param');
            history.pushState(null, null, '?' + $.param(c));
            localStorage.setItem('universal_search_param', '')
        }

        fetchHere()
    }, [])
    return (
        <>
            <div className="note container">
                <b>(0) Search results found
                    for {c.search ? c.search : localStorage.getItem('universal_search_param')}. </b>
                <span>Please look below for more help or try searching on the
                    <a href={'https://export.farnell.com/?CMP=EMEA-AVNET-ESPOT'} className='text-blue2'>
                        Farnell site</a>
                </span>
            </div>
        </>
    );
}

export default NoDataFound;